import { useAuth } from '../lib/auth'
import { GOAL, reachGoal } from '../lib/metrika'

/**
 * Аккаунт в шапке. До ответа /api/me не рисуем ничего: у залогиненного
 * человека мигание «Войти» читается как сброс сессии.
 */
export function Account() {
  const { user, ready, loginEnabled, logout } = useAuth()

  if (!ready) return null

  if (!user) {
    if (!loginEnabled) return null
    // Обычная ссылка, а не fetch: входу через OAuth нужна полноценная
    // навигация на страницу согласия Яндекса.
    return (
      <a className="account-login" href="/api/auth/yandex" onClick={() => reachGoal(GOAL.loginClick)}>
        Войти
      </a>
    )
  }

  return (
    <span className="account">
      <span className="account-name" data-testid="account-name" title={user.email ?? user.name}>
        {user.name}
      </span>
      <button className="account-exit" onClick={() => void logout()}>
        Выйти
      </button>
    </span>
  )
}
